var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.langCodes),function(lang,i){return _c('div',{key:lang,staticClass:"d-flex"},[_c('language-label',{attrs:{"language":lang,"translate":""}}),_vm._v(" "),(_vm.langCodes.length > 1 && i !== _vm.langCodes.length - 1)?_c('div',[_vm._v("  |  ")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }